import React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Timeline } from 'primereact/timeline';

export const DialogInstrucciones = ({ visible, onHide, title, items }) => {

    const headerContent = (
        <div className="flex align-items-center gap-2">
            <i className="pi pi-info-circle text-xl line-height-1"></i>
            <span className="font-bold text-lg line-height-1 m-0">{title}</span>
        </div>
    );

    const footerContent = (
        <div className="flex justify-content-end w-full pt-2">
            <Button label="Entendido" icon="pi pi-check" onClick={onHide} className="p-button-primary border-round-xl" />
        </div>
    );

    const customizedMarker = (item, index) => {
        if (item.isNote) {
            return (
                <span className="flex w-2rem h-2rem align-items-center justify-content-center text-white bg-orange-500 border-circle shadow-1 text-sm font-bold">
                    !
                </span>
            );
        }
        return (
            <span className="flex w-2rem h-2rem align-items-center justify-content-center text-white bg-blue-600 border-circle shadow-1 text-sm font-bold">
                {index + 1}
            </span>
        );
    };

    const customizedContent = (item) => {
        return (
            <div className="mb-3 text-left">
                <span className={`font-bold block mb-1 text-lg ${item.isNote ? 'text-orange-600' : 'text-blue-600'}`}>
                    {item.titulo}
                </span>

                <div className="text-700 line-height-3 text-base text-justify">
                    {item.texto}
                </div>
            </div>
        );
    };

    return (
        <Dialog visible={visible} style={{ width: '600px' }} header={headerContent} footer={footerContent} modal className="p-fluid modal-ssize dialog-personalizado" onHide={onHide}>
            <div className="m-0 px-2">
                <p className="font-semibold text-lg text-800 mb-4 mt-0">
                    Para completar el proceso, siga los pasos que se detallan a continuación:
                </p>
                <Timeline value={items || []} align="left" className="w-full p-0" marker={customizedMarker} content={customizedContent}
                    pt={{ opposite: { className: 'hidden' }, content: { className: 'pl-3' } }} />
            </div>
        </Dialog>
    );
};